import { render, staticRenderFns } from "./AdminDialog.vue?vue&type=template&id=3b33a87c&scoped=true&"
import script from "./AdminDialog.vue?vue&type=script&lang=js&"
export * from "./AdminDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b33a87c",
  null
  
)

export default component.exports